"use client";

import { useState } from "react";
import PropTypes from "prop-types";

import moment from "moment";
import "moment/locale/tr";

import { Ga4WithEventParameters } from "src/helpers/google-tag-manager/events/ga4-with-eventparameters";

import ImageSlider from "../../imageSlider";
import ShowProjectOnMap from "../projectMap";
import Button from "src/components/common/button";
import ContactFormModal from "src/components/project-detail/contact-form-modal";
import ProjectRadarSVG from "src/assets/svg/components/projectRadar/ProjectRadarSVG";

import ArrowIcon from "assets/svg/project-radar/arrow.svg";

import styles from "./styles.module.css";

const ProjectCard = ({ project, index }) => {
  const [isOpenContactForm, setIsOpeContactForm] = useState(false);
  const [isOpenMap, setIsOpenMap] = useState(false);
  const [contactFormData, setContactFormData] = useState();

  const {
    id,
    images,
    name: projectName,
    url: projectUrl,
    company,
    slug,
    deliveryDate,
    isImmediateDelivery,
    locationInfo,
  } = project || {};

  const location = { city: locationInfo?.cityName, district: locationInfo?.districtName };
  const mapLocation = { coordinate: project?.coordinates, geoShape: null }; // geoShape lazım olabilir

  const projectNameGa4EventParameters = {
    project_company_name: project?.slug,
    city: project?.locationInfo?.cityName,
    town: project?.locationInfo?.districtName,
  };

  const momentDate = moment(deliveryDate);
  momentDate.locale("tr");

  const projectDeliveryTime = isImmediateDelivery
    ? "Oturuma Hazır"
    : deliveryDate && `${momentDate.format("MMMM YYYY")} Anahtar Teslim`;

  const handleContactModal = () => {
    setIsOpeContactForm(true);
    setContactFormData({
      project: { project_name: slug, projectId: id },
      company: { project_company_name: company?.slug, companyId: company?.id },
      city: { city: locationInfo?.cityName, cityId: locationInfo?.cityId },
      town: { town: locationInfo?.districtName, townId: locationInfo?.districtId },
    });
    setTimeout(() => {
      Ga4WithEventParameters({
        eventName: "proje_radari_bilgi_click",
        eventParameters: {
          project_name: project?.slug,
          project_company_name: project?.company?.slug,
          city: project?.locationInfo?.cityName,
          town: project?.locationInfo?.districtName,
        },
      });
    }, 300);
  };

  const showOnMap = () => {
    setIsOpenMap(true);
    const gtmLabel = `${slug}-haritada-gor`;
    setTimeout(() => {
      Ga4WithEventParameters(
        {
          eventName: "proje-radari",
          eventParameters: { label: gtmLabel },
        },
        300
      );
    });
  };

  const onclickProjectNameGtmEvent = () => {
    setTimeout(() => {
      Ga4WithEventParameters(
        {
          eventName: "form",
          eventParameters: { ...projectNameGa4EventParameters, label: "click||project_name" },
        },
        300
      );
    });
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.deliveryBadge}>
        <p className={styles.badgeText}>{projectDeliveryTime}</p>
      </div>
      <div className={styles.cardContent}>
        <div className={styles.imageSliderWrapper}>
          <ImageSlider
            images={images}
            url={projectUrl}
            index={index}
            ga4EventParameters={projectNameGa4EventParameters}
          />
        </div>
        <div className={styles.contentWrapper}>
          <div className={styles.projectAndCompanyTitleWrapper}>
            <div className={styles.titleWrapper}>
              <a className={styles.title} href={projectUrl} onClick={onclickProjectNameGtmEvent}>
                {projectName}
              </a>
            </div>
            <div className={styles.companyInfoWrapper}>
              <p className={styles.companyText}>{company?.name}</p>
            </div>
          </div>
          <div className={styles.locationAndContactWrapper}>
            <div className={styles.locationWrapper}>
              <p className={styles.location}>{`${location?.city} - ${location?.district}`}</p>
              <div className={styles.showOnMap} onClick={showOnMap}>
                <p className={styles.showOnMapText}>Haritada Gör</p>
                <ArrowIcon />
              </div>
            </div>
            <Button onClick={handleContactModal} buttonClass={styles.infoFormButton}>
              Detaylı Bilgi
            </Button>
          </div>
        </div>
      </div>
      <ContactFormModal
        isOpen={isOpenContactForm}
        handleClose={() => setIsOpeContactForm(false)}
        currentCompany={company?.id}
        icon={<ProjectRadarSVG />}
        isResponsive
        isProjectRadar
        project={contactFormData}
      />
      <ShowProjectOnMap
        isOpen={isOpenMap}
        onClose={() => setIsOpenMap(false)}
        title={`${projectName} Proje Adresi`}
        location={mapLocation}
        projectId={project?.id}
      />
    </div>
  );
};

ProjectCard.propTypes = {
  project: PropTypes.object,
  index: PropTypes.number,
};

export default ProjectCard;
